var map = {
	"./en_CA/android/dark/faq.json": 67367,
	"./en_CA/android/light/faq.json": 43591,
	"./en_CA/ios/dark/faq.json": 74249,
	"./en_CA/ios/light/faq.json": 18641,
	"./fr_CA/android/dark/faq.json": 8832,
	"./fr_CA/ios/dark/faq.json": 73034
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14605;